import BaseResource from './index'
import CalendarResource from './calendar'
import LocationResource from './location'
import UserResource from './user'
import TrackResource from './track'
import CarResource, { CarSkinResource } from './car'
import SocketResource from './socketResource'

export class RaceEventResource extends SocketResource {
    static endpoint = '/races/events'
    static socketPath = 'events'
    static socketLabel = 'event'

    static related() {
        return {
            track: TrackResource,
            entries: RaceEntryResource,
            sessions: RaceSessionResource,
            preset: RacePresetResource,
            assists: AssistResource
        }
    }

    static async rebuild() {
        const result = await this.wrap('/rebuild').post()

        if (result.status == 200) {
            return true
        }

        return false
    }

    entriesByCalendar() {
        const entries = {}

        for (let entry of this.attributes.entries) {
            entries[entry.calendar] = entry
        }

        return entries
    }
}

export class RaceEntryResource extends BaseResource {
    static endpoint = '/races/entries'
    
    static related() {
        return {
            event: RaceEventResource,
            calendar: CalendarResource,
            user: UserResource,
            car: CarResource,
            skin: CarSkinResource,
        }
    }
}

export class RaceSessionResource extends BaseResource {
    static endpoint = '/races/sessions'
    static sessionTypes = ['HOTLAP', 'PRACTICE', 'QUALIFYING', 'RACE']
    static sessionTypesMultiplayer = ['PRACTICE', 'QUALIFYING', 'RACE']
    static spawnTypes = ['PIT', 'START', 'HOTLAP_START']

    static related() {
        return {
            event: RaceEventResource,
        }
    }
}

export class RacePresetResource extends BaseResource {
    static endpoint = '/races/presets'

    static related() {
        return {
            user: UserResource,
            car: CarResource,
            skin: CarSkinResource,
            assists: AssistResource,
            track: TrackResource,
        }
    }

    async quickstart(calendarId, trackId, carId) {
        const result = await this.wrap('/quickstart').post({ calendar: calendarId, track: trackId, car: carId })

        if (result.status == 200) {
            return result.data
        }
    }
}

export class RacePresetUserResource extends RacePresetResource {
    static endpoint = '/races/presets/user'
}

export class AssistResource extends BaseResource {
    static endpoint = '/assists'
}

export class WeatherPresetResource extends BaseResource {
    static endpoint = '/races/weather/presets'
}

export class PartyResource extends BaseResource {
    static endpoint = '/races/parties'

    static related() {
        return {
            location: LocationResource,
            members: PartyMemberResource,
            member_requests: PartyInvitiationResource,
        }
    }

    static async host(hostCalendarId, name, otherCalendarIds = []) {
        const response = await this.wrap('/host').post({ name, calendar: hostCalendarId, other_calendars: otherCalendarIds })

        if ([200, 201].includes(response.status)) {
            return new PartyResource(response.data)
        }
    }

    async delete() {
        const host = this.rel('members').resources.find((member) => member.attributes.is_host)
        
        if (host) {
            await host.delete()
        } else {
            super.delete()
        }
    }

    async addMember(calendarId) {
        const membership = new PartyMemberResource({
            party: this.id,
            calendar: calendarId
        })

        return await membership.save()
    }
}

export class PartyMemberResource extends BaseResource {
    static endpoint = '/races/parties/members'

    static related() {
        return {
            party: PartyResource,
            calendar: CalendarResource,
            user: UserResource,
        }
    }
}

export class PartyInvitiationResource extends BaseResource {
    static endpoint = '/races/parties/invitations'

    static related() {
        return {
            party: PartyResource,
            calendar: CalendarResource
        }
    }
}

